import Vue from 'vue'
import memberApi from '@/api/member.api'

const state = {
  members: {}
}


const getters = {
  memberById: (state) => (projectId, id) => {
    return (state.members[projectId] || []).find(x => x.id === id)
  },

  membersByProject: (state, getters, rootState, rootGetters) => (projectId, includeContact = true) => {
    let list = (state.members[projectId] || [])
    if (includeContact) {
      list = list.map(member => {
        return {
          ...member,
          contact: rootGetters['contact/shortContactById'](member.contactId) || {}
        }
      })
    }
    return list
  }
}


const actions = {
  async loadMembersByProject ({ commit, rootState }, projectId) {
    const response = await memberApi.getMembers(rootState.tenant.current, projectId)
    commit('SET_MEMBERS', { projectId, members: response.data })
  },

  async loadAndUpdateMember ({ commit, rootState }, entityData) {
    const response = await memberApi.getMember(rootState.tenant.current, entityData.projectId, entityData.entityId)
    const member = response.data
    if (state.members[member.projectId]?.find(x => x.id === member.id)) {
      commit('UPDATE_MEMBER', member)
    }
    return response.data
  },

  async createMember ({ commit, rootState }, member) {
    const response = await memberApi.createMember(rootState.tenant.current, member)
    commit('CREATE_MEMBER', response.data)
  },

  async updateMember ({ commit, rootState }, member) {
    const response = await memberApi.updateMember(rootState.tenant.current, member.projectId, member.id, member)
    commit('UPDATE_MEMBER', response.data)
  },

  // async updateMemberDataById ({ commit, rootState }, member) {
  //   if (state.members[member.projectId]?.find(x => x.id === member.id)) {
  //     commit('UPDATE_MEMBER', member)
  //   }
  // },

  async deleteMember ({ commit, rootState }, { projectId, id }) {
    await memberApi.deleteMember(rootState.tenant.current, projectId, id)
    commit('DELETE_MEMBER', { projectId, id })
  }
}


const mutations = {
  SET_MEMBERS (state, { projectId, members }) {
    Vue.set(state.members, projectId, members)
  },

  CREATE_MEMBER (state, member) {
    const projectId = member.projectId

    if (!state.members[projectId]) {
      Vue.set(state.members, projectId, [member])
    } else {
      state.members[projectId].push(member)
    }
  },

  UPDATE_MEMBER (state, member) {
    const _member = state.members[member.projectId].find(x => x.id === member.id)
    _member.id = member.id
    _member.name = member.name


    _member.contactId = member.contactId
    _member.projectId = member.projectId
    _member.contact = member.contact
    _member.dietDays = member.dietDays
    _member.dietPerDay = member.dietPerDay
    _member.totalDiet = member.totalDiet
    _member.hotelDays = member.hotelDays
    _member.hotelPerDay = member.hotelPerDay
    _member.totalHotels = member.totalHotels
    _member.otherCost = member.otherCost
    _member.totalCost = member.totalCost
    _member.wage = member.wage
    _member.function = member.function
    _member.travelCost = member.travelCost
  },

  DELETE_MEMBER (state, { projectId, id }) {
    const i = state.members[projectId].findIndex(x => x.id === id)
    state.members[projectId].splice(i, 1)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
